import {visible} from './jquery.visible.min.js';
var mobVersion;
var desktopVersion;


jQuery(function($) {
    if ($('.video-background').length) { 
        var mainVideo = document.getElementById('hero-video');
        mobVersion = 'https://jask-video-assets.s3.amazonaws.com/unmarked/hero_mob.mp4';
        desktopVersion = 'https://jask-video-assets.s3.amazonaws.com/unmarked/hero_desktop.mp4';
        var videoSource;
        $(window).on('load', function(){
            videoSource = document.createElement('source');
            if ($(window).width() < 768 && mobVersion) {
                videoSource.setAttribute('src', mobVersion);
                videoSource.setAttribute('data-version', 'mobile');
            } else {
                videoSource.setAttribute('src', desktopVersion);
                videoSource.setAttribute('data-version', 'desktop');
            }
            mainVideo.appendChild(videoSource);
            mainVideo.load(); 
            mainVideo.play(); 
        });
        $(window).on('resize', function(){
            if ($(window).width() < 768 && mobVersion) {
                if (videoSource && videoSource.getAttribute('data-version') != "mobile") {
                    mainVideo.pause();
                    videoSource.setAttribute('data-version', 'mobile');
                    videoSource.setAttribute('src', mobVersion);
                    mainVideo.load(); 
                }
            } else {
                if (videoSource && videoSource.getAttribute('data-version') != "desktop") {
                    mainVideo.pause();
                    videoSource.setAttribute('data-version', 'desktop');
                    videoSource.setAttribute('src', desktopVersion);
                    mainVideo.load(); 
                }
            }
        });
    }
    // Page has video(s)
    if($('.video').length > 0) {
        // Add vimeo player source if page contains a video, no point in loading it in on every page
        // $('head').prepend('');

        var videos = $('.video');
        var iframe = null;
        var player = null;
        var in_viewport = null;
        var video_visible = null;
        var desktop_video = null;
        var mobile_video = null;
        var players = [];
        var breakpoints = {
            mobile: 768,
            tablet: 768,
        };

        // List of Vimeo player options taken from src
        // var v = [
        //     "autopause",
        //     "autoplay",
        //     "background",
        //     "byline",
        //     "color",
        //     "controls",
        //     "dnt",
        //     "height",
        //     "id",
        //     "loop",
        //     "maxheight",
        //     "maxwidth",
        //     "muted",
        //     "playsinline",
        //     "portrait",
        //     "responsive",
        //     "speed",
        //     "texttrack",
        //     "title",
        //     "transparent",
        //     "url",
        //     "width"
        // ];

        var options = {
            autoplay: true,
            loop: true,
            controls: false,
            muted: true,
            autopause: false
        }

        var videoData = [];

        if($('body').hasClass('home')) {
            // homepage
            // if current video id !== video id for current device size (mobile / desktop) swap out for correct video
            console.log('home');

            var base_url = 'https://player.vimeo.com/video/{VIDEO_ID}?muted=1&autoplay=1&controls=0&loop=1&app_id=122963';
            var video = $('.video');
            var iframe = $(video).find('iframe');

            var desktop_video = video.attr('data-video-id');
            var mobile_video = video.attr('data-mobile-video');
            var video_to_play = window.matchMedia('(max-width: 768px)').matches ? mobile_video : desktop_video;
            var final_url = base_url.replace('{VIDEO_ID}', video_to_play);
            var current_video = video_to_play;

            console.log(video_to_play);

            iframe.attr('src', final_url);

            $(window).resize(function() {
                var video_to_play = window.matchMedia('(max-width: 768px)').matches ? mobile_video : desktop_video;

                if(video_to_play !== current_video) {
                    iframe.css('display', 'none')
                    iframe.attr('src', null);

                    var final_url = base_url.replace('{VIDEO_ID}', video_to_play);
                    iframe.attr('src', final_url);
                    current_video = video_to_play;

                    iframe.on('load', function() {
                        iframe.css('display', 'block');
                    });

                    iframe.onreadystatechange = function() {
                        while(iframe.readyState !== 'complete') {
                            console.log(iframe.readyState);
                        }

                        console.log('state change');
                    };
                }
            });
        } else {
            
            // On initial load
            videos.each(function(index, value) {

                iframe = $(value);
                desktop_video = iframe.attr('data-video-id');
                mobile_video = iframe.attr('data-mobile-video');

                if(window.matchMedia('(max-width: 768px)').matches) {
                    options['id'] = mobile_video;
                    videoData[index] = {
                        player: new Vimeo.Player(iframe, options)
                    }
                } else {
                    options['id'] = desktop_video;
                    videoData[index] = {
                        player: new Vimeo.Player(iframe, options)
                    }
                }

                if ($(value).hasClass('pop-out-video')) {
                    console.log('pop-out-video');
                }

            });

            $(window).scroll(function() {

                var scrollPos = $(window).scrollTop();
                var windowHeight = $(window).height();

                videos.each(function(index, value) {

                    iframe = $(value);
                    desktop_video = iframe.attr('data-video-id');
                    options['id'] = desktop_video;

                    var videoTop = $(value).offset().top;
                    var videoHeight = $(value).outerHeight();
                    var videoBottom = videoTop + $(value).outerHeight();
                    var windowBottom = scrollPos + (windowHeight + videoHeight);
                    var windowTop = scrollPos;
                    var videoVisible =  (videoBottom < windowBottom && (videoTop + videoHeight) > windowTop)

                    if (videoVisible) {
                        videoData[index].player.play();
                        console.log('play');
                    } else {
                        videoData[index].player.pause();
                        console.log('pause');
                    }

                });
            });
        }
    }

    // $('.pop-out-video .action a').bind('click', function(e){
    //     var video_height = $(this).parents('.pop-out-video').outerHeight();
    //     $(this).parents('.pop-out-video').addClass('active-feature-video');
    //     $('.active-feature-video').after('<div class="video-overlay-spacer" style="height: ' + video_height + 'px;"></div>');
        
    //     var videos = $('.video');

    //     videos.each(function(index, value) {
    //         if (!$(value).hasClass('active-feature-video')) {
    //             videoData[index].player.pause();
    //         } else {
    //             //send the video fullscreen and unmute sound
    //             videoData[index].player.setCurrentTime(0);
    //             // videoData[index].player.requestFullscreen();
    //             videoData[index].player.setVolume(1);
    //         }
    //     });

    //     e.preventDefault();
    // });

    // $('.pop-out-video .close a').bind('click', function(e){
    //     $(this).next('.video-overlay-spacer').remove();
    //     videos.each(function(index, value) {
    //         if ($(value).hasClass('active-feature-video')) {
    //             videoData[index].player.setVolume(0);
    //         }
    //     });
    //     $(this).parents('.pop-out-video').removeClass('active-feature-video');
    //     e.preventDefault();
    // });

    // New Logical

    $('.pop-out-video .action a').bind('click', function(e) {
        e.preventDefault();

        var $popOut = $(this).parents('.pop-out-video');
        var video_height = $popOut.outerHeight();
        $popOut.addClass('active-feature-video');
        $('.active-feature-video').after('<div class="video-overlay-spacer" style="height: ' + video_height + 'px;"></div>');

        var videos = $('.video');

        videos.each(function(index, value) {
            var $videoEl = $(value);

            if (!$videoEl.hasClass('active-feature-video')) {
                videoData[index].player.pause();
            } else {
                // Detect if the video is on mobile and set the correct video
                var isMobile = window.matchMedia('(max-width: 768px)').matches;
                var mobileVideo = $videoEl.attr('data-mobile-video');

                if (isMobile && mobileVideo) {
                    var iframe = $videoEl.find('iframe');
                    if (iframe.length) {
                        var finalUrl = 'https://player.vimeo.com/video/' + mobileVideo + '?muted=0&autoplay=1&controls=0&loop=1&app_id=122963';
                        iframe.attr('src', finalUrl);
                    }
                }

                videoData[index].player.setCurrentTime(0);
                videoData[index].player.setVolume(1);
            }
        });
    });

    $('.pop-out-video .close a').bind('click', function(e){
        e.preventDefault();

        var $popOut = $(this).parents('.pop-out-video');
        var iframe = $popOut.find('iframe');
        var desktopVideo = $popOut.attr('data-vimeo-id');

        // Reset the video iframe source to the desktop version
        if (iframe.length && desktopVideo) {
            var finalUrl = 'https://player.vimeo.com/video/' + desktopVideo + '?muted=1' + '&autoplay=1&controls=0&loop=1&app_id=122963';
            iframe.attr('src', finalUrl);
        }

        // Remove the spacer
        $('.video-overlay-spacer').remove();

        // Silence all other videos
        videos.each(function(index, value) {
            if ($(value).hasClass('active-feature-video')) {
                videoData[index].player.setVolume(0);
            }
        });

        // Remove the active class
        $popOut.removeClass('active-feature-video');
    });

    //on pressing the escape key, close the video
    $(document).keyup(function(e) {
        if (e.key === "Escape") {
            if ($('.active-feature-video').is(':visible')) {
                $('.active-feature-video .close a').click();
            }
        }
    });
});